import { useCvDownload } from "@/domains/company/anonymization/useCvDownload";
import { useDownloadAnonymousCv, useDownloadAnonymousCvBundle } from "../api";

/**
 * Download dei CV anonimi dalla ricerca attiva: lega le mutation di questo
 * dominio (endpoint autorizzati sulla discoverability) alla regola condivisa
 * "uno → PDF, due o più → ZIP".
 */
export const useSearchCvDownload = (onDownloaded?: () => void) => {
  const single = useDownloadAnonymousCv();
  const bundle = useDownloadAnonymousCvBundle();

  return useCvDownload(
    {
      single: {
        /* `onSuccess` per-chiamata: si somma a quello dell'hook (che salva il
           file e fa il toast), non lo sostituisce, e corre dopo di esso. */
        mutate: (freelancerId, onSuccess) =>
          single.mutate({ freelancerId }, { onSuccess }),
        get isPending() {
          return single.isPending;
        },
      },
      bundle: {
        mutate: (freelancerIds, onSuccess) =>
          bundle.mutate({ freelancer_ids: freelancerIds }, { onSuccess }),
        get isPending() {
          return bundle.isPending;
        },
      },
    },
    onDownloaded,
  );
};
